<template>
  <b-overlay :show="loading" rounded="sm">
    <b-container>
      <div class="section-one">
        <b-row class="welcome">
          <b-col cols="12">
            <img v-if="imageFirstPlace" src="../Img/first_place.svg" class="img_place" alt="third_place">
            <img v-if="imageSecondPlace" src="../Img/second_place.svg" class="img_place" alt="third_place">
            <img v-if="imageThirdPlace" src="../Img/third_place.svg" class="img_place" alt="third_place">
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="title-score" v-html="placeTitle" tabindex="0" />
          </b-col>
        </b-row>
        <b-row class="row-score">
          <b-col v-if="score <= 100" :cols="score === 100 ? 6 : 5" style="padding-right: 9em">
            <span class="title-number-score" tabindex="0">{{ $t("score") }}</span><br>
            <span class="number-score" tabindex="0">{{score}}</span>
          </b-col>
          <b-col cols="6">
          <span class="description-score" tabindex="0">
            {{placeDescription}}
          </span>
          </b-col>
        </b-row>
      </div>
      <div class="section-two">
        <b-col cols="12" class="section-topics">
          <span class="title-topics" tabindex="0">{{ $t("topics_from_quiz") }}</span>
          <ul class="topics" tabindex="0">
            <li v-for="competency in competencies" :key="competency.id">
              {{ $t(competency.nameLocalizationKey) }}
            </li>
          </ul>
        </b-col>
        <b-col cols="12" class="padding-left-zero">
          <span class="title-topics" tabindex="0">{{ $t("what_next") }}</span>
        </b-col>
        <b-col cols="12" class="description-topics padding-left-zero" tabindex="0">
        <span>
          {{ $t("checkout_links") }}
        </span>
        </b-col>
        <b-row class="topics-section">
          <b-col v-if="learnEarnLink">
            <a target="_blank" :href="learnEarnLink"><img src="../Img/learnEarn.png" :alt="learnEarnLinkName"></a>
            <div class="title-course purple-text" tabindex="0">{{ $t("learn_earn") }}</div>
            <span class="link-name" tabindex="0">{{ learnEarnLinkName }}</span>
          </b-col>
          <b-col v-if="clpLink">
            <a target="_blank" :href="clpLink"><img src="../Img/clp.png" :alt="clpLinkName"></a>
            <div class="title-course purple-text" tabindex="0">{{ $t("connect_lp") }}</div>
            <span class="link-name" tabindex="0">{{ clpLinkName }}</span>
          </b-col>
        </b-row>
        <b-col cols="12" class="butt-welc">
          <b-button class="retake-test" variant="primary" type="button"
                    v-on:click="retakeTest" v-on:keyup.enter.space="retakeTest" tabindex="0">
            {{ $t("button_retake_test") }}
          </b-button>
          <img src="../Img/ja-logo.svg" class="center-img mt-4" alt="JA-LOGIN">
        </b-col>
      </div>
      <div class="section-third" v-if="isAuthenticate">
        <b-col cols="12" >
        <span class="title-topics" tabindex="0">
          {{ $t("save_score_title") }}
        </span>
        </b-col>
        <b-col cols="12" class="description-topics" tabindex="0">
          <span>{{ $t("save_score_desc") }}</span>
        </b-col>
        <b-form @submit.prevent="login()">
          <b-row>
            <b-col cols="12">
              <b-col cols="12" class="mt-3">
                <label for="email" class="label-login">{{ $t("label_email") }}</label>
                <input id="email" type="text" class="input-login"
                       placeholder="name@domain.com" v-model="form.email" value="" tabindex="0">
                <span v-if="emailError" class="form-error">{{ $t("error_required_field") }}</span>
              </b-col>
            </b-col>
            <b-col cols="12">
              <b-col cols="12 mt-1">
                <label for="password" class="label-login">{{ $t("label_password") }}</label>
                <input id="password" type="password" class="input-login"
                       placeholder="At least 8 characters" v-model="form.password" value="" tabindex="0">
                <span v-if="passwordError" class="form-error">{{ $t("error_required_field") }}</span>
              </b-col>
            </b-col>
            <b-col cols="12">
              <b-col cols="12" class="mt-4">
                <b-button block variant="primary" type="submit" tabindex="0">{{ $t("login_button") }}</b-button>
              </b-col>
            </b-col>
            <b-col cols="12" class="mt-4 text-center">
              <router-link :to="{ name: 'ForgotPassword' }">
                <span class="purple-text">{{ $t("forgot_password") }}</span>
              </router-link>
            </b-col>
            <b-col cols="12" class="mt-4 mb-4 text-center">
              <span class="grey-text">{{ $t("dont_have_account") }}</span>
              &nbsp;
              <router-link :to="{ name: 'Register' }">
                <span class="purple-text">{{ $t("register_register") }}</span>
              </router-link>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </b-container>
  </b-overlay>
</template>

<script>
import {Storage} from "../../../core/Utils"
import validateForms from '../../../core/Mixins/validate-forms'
import {AuthService} from "../../Security/Services"
import {QuestionService} from "../../Home/Services"

export default {
  name: "IncomeKnowledgePage",
  mixins: [validateForms],
  data() {
    return {
      loading: true,
      form: {email: "", password: ""},
      emailError: false,
      passwordError: false,
      serviceError: null,
      serviceErrorDetail: false,
      hasError: false,
      hasErrorEmailNoConfirmed: false,
      score: 0,
      imageFirstPlace: false,
      imageSecondPlace: false,
      imageThirdPlace: false,
      placeDescription: "",
      placeTitle: [],
      isAuthenticate: false,
      competencies: [],
      questionsAnswered: [],
      learnEarnLinkName: null,
      learnEarnLink: null,
      clpLinkName: null,
      clpLink: null
    }
  },
  methods: {
    retakeTest: function() {
      this.loading = true
      Storage.setInitialTimestamp(Date.now())
      Storage.removeItemAnswers()
      if (navigator.onLine) {
        QuestionService.loadQuestionsAndCompetencies().then(() => {
          this.$router.push({name: 'Welcome'})
        }).catch(() => this.loading = false)
      } else {
        this.$router.push({name: 'Welcome'})
      }
    },
    loadCompetencies: function() {
      this.competencies = Storage.getCompetencies();
    },
    loadLinks: function() {
      const competencyCount = {}
      const competencyWeighted = {}
      const learnEarnCourses = []
      const clpCourses = []

      const getRandomItemFromArray = (array) => {
        const randomIndex = Math.floor(Math.random() * array.length)
        return array[randomIndex]
      }

      // init values
      this.competencies.forEach(competency => {
        competencyCount[competency.id] = 0
        competencyWeighted[competency.id] = 0
      })
      const questions = Storage.getQuestions()
      // count questions and correct questions by competency
      this.questionsAnswered.forEach(qa => {
        const question = questions.find(q => q.id === qa.id)
        competencyCount[question.competency.id] = competencyCount[question.competency.id] + 1
        competencyWeighted[question.competency.id] = competencyWeighted[question.competency.id] + qa.value ? 1 : 0
      })
      // set correct questions weight by competency
      let minWeight = 100
      this.competencies.forEach(competency => {
        const weight = Math.round(competencyWeighted[competency.id] * 100 / competencyCount[competency.id])
        competencyWeighted[competency.id] = weight
        if (weight < minWeight) {
          minWeight = weight
        }
      })
      // filter competencies by minWeight
      const minWeightCompetencies = this.competencies.filter(c => competencyWeighted[c.id] === minWeight)
      const selectedCompetency = getRandomItemFromArray(minWeightCompetencies)
      // sort courses by platform
      if(selectedCompetency &&
        selectedCompetency.courses &&
        Array.isArray(selectedCompetency.courses) &&
        selectedCompetency.courses.length > 0){

        selectedCompetency.courses.forEach(c => {
          if (c.platform === 'Learn & Earn') {
            learnEarnCourses.push(c)
          } else {
            clpCourses.push(c)
          }
        })

        // get random courses from competencies not answered correctly
        const learnEarnCourse = getRandomItemFromArray(learnEarnCourses)
        const clpCourse = getRandomItemFromArray(clpCourses)

        this.learnEarnLink = learnEarnCourse.link
        this.learnEarnLinkName = this.$t(learnEarnCourse.nameLocalizationKey)
        this.clpLink = clpCourse.link
        this.clpLinkName = this.$t(clpCourse.nameLocalizationKey)
      }
    },
    calculateScoreTest: function() {
      let scoreTest = 0;
      this.questionsAnswered.forEach(function(questionAnswered){
        if(questionAnswered.value){
          scoreTest = scoreTest + 10;
        }
      });
      this.score = scoreTest;
      Storage.saveUserScore(this.score);
    },
    selectImagePlace: function(){
      if(this.score < 50){
        this.imageThirdPlace = true;
        this.placeDescription = this.$t("third_place_desc")
        this.placeTitle = this.$t("third_place_title")
      } else if(this.score < 75) {
        this.imageSecondPlace = true;
        this.placeDescription = this.$t("second_place_desc")
        this.placeTitle = this.$t("second_place_title")
      } else if(this.score <= 100) {
        this.imageFirstPlace = true;
        this.placeDescription = this.$t("first_place_desc")
        this.placeTitle = this.$t("first_place_title")
      }
    },
    login: function() {
      const email = this.form.email
      const password = this.form.password
      this.emailError = email === ""
      this.passwordError = password === ""
      this.hasError = false;
      this.hasErrorEmailNoConfirmed = false
      this.serviceError = null
      this.serviceErrorDetail = false

      this.loading = true

      if (email && password && this.isValidform()) {
        AuthService.login(email, password).then(() => {
          this.loading = false
          this.$router.push({name: 'Welcome'})
        }).catch(err => {
          this.loading = false
          this.hasError = true;
          this.serviceError = this.$t("error_unexpected")
          if (err) {
            if (err.message && err.message === 'Email_No_Confirmed') {
              this.serviceError = this.$t("error_email_not_verified")
              this.serviceErrorDetail = ''
              this.hasErrorEmailNoConfirmed = true
            } else {
              this.serviceError = this.$t("error_invalid_credentials")
              this.serviceErrorDetail = this.$t("error_invalid_credentials_details")
              this.hasErrorEmailNoConfirmed = false
            }
          }
        })
      }
    },
    isValidAuthenticate: function(){
      let user = Storage.getUser();
      return Object.keys(user).length === 0;
    }
  },
  mounted() {
    this.loading = true
    this.isAuthenticate = this.isValidAuthenticate();
    this.questionsAnswered = Storage.getAnswers();
    this.calculateScoreTest();
    this.selectImagePlace();
    this.loadCompetencies();
    this.loadLinks()
    this.loading = false
  }
}
</script>

<style lang="stylus" scoped>
  @import "../../Security/Styles/security_styles.styl"
  @import "~@/core/Styles/variables.styl"

  .center-img
    display block
    margin-left auto
    margin-right auto

  .section-one
    background linear-gradient(209deg, color-yellow, color-orange-bright)
    padding-bottom 1px
    height 100%
    padding-left 20px
    padding-right 20px
    overflow-x hidden

  .topics-section
    margin-top 20px

  .section-two
    background #EDEDED
    height 100%
    padding-top 40px
    padding-left 25px
    padding-right 25px

  .title-course
    margin-top 10px
    font-weight bold

  .link-name
    overflow-wrap break-word

  .section-third
    background color-white
    height 100%
    padding-top 40px
    padding-bottom 40px
    padding-left 25px
    padding-right 25px

  .description-topics
    margin-top 10px

  .section-topics
    padding-bottom 20px
    padding-left 0

  .padding-left-zero
    padding-left 0

  .topics
    margin-top 10px
    padding-left 20px

  .row
    margin-right -10

  .img_place
    margin-top 40px
    width 360px
    right -60px

  .welcome
    text-align right

  .row-score
    margin-bottom 20px

  .title-score
    color color-black
    font font-roboto-bold
    position relative
    top -1.5em
    font-size 32px
    border-bottom 1px solid black

  .title-topics
    color color-black
    font font-roboto-bold
    font-size 20px

  .title-number-score
    color color-black
    font font-roboto-bold
    font-size 14pt

  .number-score
    color color-black
    font font-roboto-bold
    font-size 88pt
    position relative
    top -30px

  .description-score
    color color-black
    font font-opensans
    line-height 21px

  .content-score
    color color-black
    font font-opensans
    line-height 21px

  .retake-test
    width 90%
    font font-opensans-cond

    &:hover
      background color-orange
      border solid 2px color-orange

  .butt-welc
    text-align center
    margin-top 40px
    padding-bottom 60px

  .container
    padding-left 0
    padding-right 0
</style>
